import 'isomorphic-fetch';
import assign from 'object-assign';
import isObject from 'lodash/isObject';
import queryString from 'query-string';
import {clearApiHandle, processApiHandle} from '../lib/util/apiHandle';
import errorTip from '../lib/util/errorTip'
import {API_ROOT, API_CODE_SUCCESS} from '../config';

export const CALL_API = 'Call API';

const API_ROOT_DEFAULT = '/';
let serverTimeDelta = 0;

function callApi({
	 endpoint,
	 params,
	 methods = 'POST',
	 json = false,
	 customHeaders = {"Content-Type": 'application/x-www-form-urlencoded'}
	}) {
	let fullUrl = API_ROOT + API_ROOT_DEFAULT + endpoint;
	const headers = new Headers();

	Object.keys(customHeaders).forEach((k) => {
		headers.append(k, customHeaders[k]);
	});
	let body;
	if (headers.get("Content-Type") === 'application/json') //post json
	{
		body = JSON.stringify(params);
	}
	else if(headers.get("Content-Type") === 'application/x-www-form-urlencoded')
	{
			body = queryString.stringify(params);
	}
	else //raw content
	{
		body = params;
	}

	let fetchParams = {
		method:methods,
		headers,
		body,
		credentials: 'include'
	}

	if (methods === 'GET') {
		fullUrl += fullUrl.indexOf('?') === -1 ? `?${queryString.stringify(params)}` : `&${queryString.stringify(params)}`
		delete fetchParams.body;
	}

	return fetch(fullUrl, fetchParams).then(response => {
		// 请求失败处理
		if (!response.ok) {
			return Promise.reject({
				retCode: response.status,
				retMsg: response.statusText
			});
		}
		// 请求数据处理
		return response.json();
	}).then(json => {
		if (json.retCode !== 0) {
			return Promise.reject(json);
		}

		const timeDelta = json.time * 1000 - Date.now();

		serverTimeDelta = timeDelta;

		return assign({}, {result: json.retData}, {retMsg: json.retMsg}, {timeDelta});
	}).catch((err) => {
		// 捕获的error
		if (err instanceof Error) {
			return Promise.reject({
				retCode: err.code || -1,
				retMsg: err.message
			});
		// 手动抛出obj
		} else if (isObject(err)) {
			return Promise.reject(err);
		}
		// 手动抛出str
		return Promise.reject({
			retCode: -1,
			retMsg: `${err}`
		});
	});
}

export default store => next => action => {
	const callAPI = action[CALL_API];
	// 非callAPI action处理
	if (typeof callAPI === 'undefined') {
		return next(action);
	}
	// callAPI action处理
	let {endpoint} = callAPI;

	// apiHandleOpt 错误处理操作配置
	const {types, params = {}, schema, showLoading, methods, json, customHeaders, apiHandleOpt, errHandle = true} = callAPI;
	const state = store.getState();

	if (typeof endpoint === 'function') {
		endpoint = endpoint(state);
	}

	if (typeof endpoint !== 'string') {
		throw new Error('Specify a string endpoint URL.');
	}
	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected an array of three action types.');
	}

	// 删除CALL_API，重构action供下一个Middleware使用
	function actionWith(data) {
		const finalAction = assign({}, action, data);
		delete finalAction[CALL_API];
		return finalAction;
	}

	const [requestType, successType, failureType] = types;
	// 请求开始处理
	const actionObj = {
		type: requestType
	};
	// 加载动画
	if (showLoading) {
		actionObj.showLoading = showLoading;
	}
	// 重置apiHandle的action对象，请求失败时使用 ApiHandleOpt类 level
	// apiHandleOpt => boolean undefined ApiHandleOpt类 实例
	// => apiHandleOpt 
	const apiHandleOptResult = clearApiHandle(actionObj, apiHandleOpt);

	next(actionObj);

	return callApi({
		endpoint,
		params,
		schema,
		methods,
		json,
		customHeaders
	}).then((response) => {
		// 请求成功
		if (showLoading) {
			next(actionWith({
				response,
				type: successType,
				showLoading: false
			}));
		} else {
			next(actionWith({
				response,
				type: successType
			}));
		}
		
		return {
			retCode: API_CODE_SUCCESS,
			retMsg: response.retMsg,
			retData: response.result
		};
	}, ({retCode, retMsg, retData}) => {
		// 请求失败
		const actionObj = {
			type: failureType,
			error: retMsg,
			code: retCode
		};
		if (showLoading) {
			actionObj.showLoading = false;
		}
		// apiHandleOptResult => {code: 10001, error: '失败', type: 'PROCESS_START_FAILURE', apiHandle: {level: 1, msg: '失败'}}
		let obj = processApiHandle(actionObj, retCode, retMsg, apiHandleOptResult);

		// callAPI errHandle 为true时， 统一提示错误
		!!errHandle && errorTip(retCode, retMsg)

		next(actionWith(actionObj));

		return {
			retCode,
			retMsg,
			retData
		};
	});
};

export function getServiceTime() {
	return Date.now() + serverTimeDelta;
}




// WEBPACK FOOTER //
// ./src/middleware/api.js